<div class="w-100">
  <div class="position-relative w-100" (document:click)="handleOutsideClick($event)">
    <!-- When user clicks the following div only, then toggle the below div -->
    <div class="d-flex justify-content-between dropdown-input" >
      <p *ngIf="!selectedItems.length" class="mb-0">{{placeHolder}}</p>
      <div class="d-flex selected-items-container">
        <!-- Loop through the first 5 items only -->
        <div class="item" *ngFor="let item of selectedItems.slice(0, 5)">
          {{ item.code3 }}
          <button class="close-btn" (click)="removeItem(item)">x</button>
        </div>
        
        <!-- If there are more than 5 items, show a "X more" message -->
        <p *ngIf="selectedItems.length > 5" class="more-items mb-0"><span>+{{selectedItems.length - 5}}</span> more</p>
      </div>
      
      
      <div class="">
        <ion-button class="dropdown-btn" fill="clear" (click)="toggleDropdown($event)"><ion-icon name="chevron-down-outline"></ion-icon></ion-button>
      </div>
    </div>

    <!-- Dropdown list, initially hidden -->
    <div class="dropdown-list-main" [ngClass]="{'dropdown-list-main-top' : dropdownOnTop}" *ngIf="dropdownVisible">
      <div class="sticky-top d-flex search-container align-items-center pt-1">
        <!-- <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()">    -->
        <input type="text" placeholder="Search Item" [(ngModel)]="searchTerm" (input)="onSearch($event)">
         <!-- <label for="" class="label">Select all</label> -->
      </div>
      <div class="dropdown-list">
        <div class="item d-flex" *ngFor="let item of filteredItems">
          <input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item)">
          <p>{{item.name}}</p>
        </div>
        <div class="item" *ngIf="filteredItems.length === 0">
          <p >No results found!</p>
        </div>
      </div>
    </div>
  </div>
</div>
